<template>
	<div class="ReClientChatNest"  >

		<!-- <div class="d-flex justify-content-center " > <h3>ЛЕНТА СООБЩЕНИЙ</h3> </div> -->
		<!-- <div class="col-12 col-xl-6 px-0" ></div> -->
		<card class="postForm mb-3" :class="{'focus-shadow' : !bIsPostForm}" v-if="contact">
			<div class="postForClick" @click="showPostForm()">
				<h5><i class="tim-icons icon-send text-success mr-3"></i>Написать</h5>
			</div>
			<div v-if="!bIsPostForm" class="cancel-note-btn">
				<base-button  @click="cancelForm()" type="danger" class="no-border" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
			</div>
			<div class="postAddForm" 
			:class="[bIsPostForm ? 'postAddForm-hide' : 'postAddForm-show']"
			>		
				<form class="form-container">
					<div class="top_part">           
						<textarea 
						class="form-control"
						placeholder="Текст"
						ref="saveInput"						
						v-model="strNote">	
						</textarea>	
					</div>
					<div class="bottom_part mt-2 pb-1">
						<!-- <template v-if="fileUpload_model==''">
							<div class="upload-file"> 
								<ReFileUpload 
									v-model="fileUpload_model"
									type="file"
									:multiple="false"
									
									acceptMime="*/*"
									:bShowTrash="false"
									v-on:change="OnUploadFile"
								/>
							</div>
						</template>
						<template v-else>
							<h5 class="upload-file">
								<a :href="fileUpload_model.fullpath" target="_blank">Посмотреть документ</a>
								<button class="ml-2 btn btn-icon btn-simple btn-danger" @click="DoDel()">
									<i class="tim-icons icon-trash-simple"></i>
								</button>
							</h5>
						</template> -->
						
						<base-button v-if="strNote!=''" type="success" simple icon @click="SendNote()" class="mr-0">
						<i class="d-inline-block tim-icons icon-send"></i>
						</base-button>		
														
					</div>
				</form>						
			</div>
		</card>

		<template v-if="masLenta.length > 0">
			<!-- <div v-for="message in masLenta" :key="message.id" class="lenta-item" :class="[message.direction == 'in' ? 'ml-auto' : 'mr-auto']">  -->
			<div v-for="message in masLenta" :key="message.id" class="lenta-item" > 
				<div class="note-btn-group" >
					<ReClientNoteMsg 
					:class="[(message.direction == 'in') ? 'msgDirectionIn' : 'msgDirectionOut']"
					:objNote="message"  
					@onUpdate="getLenta()"/>
				</div>
			</div>
				<Pagination :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
				:type="'primary'" 
				:total="parseInt(masApi_total)" 
				:perPage="parseInt(10)" 
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>	
		</template>



			<!-- <div class="pagination" v-if="bShowPaginBtn"><base-button @click="pClick()" class="mx-auto" type="success" simple>Загрузить ещё</base-button></div>	 -->
			
		
		<!-- <pre>{{masLenta}}</pre> -->

	</div>
</template>

<script>

// import ReFileUpload from "src/our_components/ReFileUpload.vue";
import ReClientNoteMsg from "src/our_components/ReClientNoteMsg.vue";
import {eventEmitter} from "src/plugins/globalComponents.js";
import moment from 'moment';
// import VueMoment from 'vue-moment';
import Pagination from 'src/our_components/RePagination';

export default {
	name: 'ReClientChatNest',
	components: {
		// ReFileUpload,
		ReClientNoteMsg,
		Pagination,

	},
	props: {
		client_id: [String,Number],	
		client_name: String,
		contact: String,
		contactType: String,
		type:{
			type: String,
			default: 'client',
		},
	},
	data () {
		return {
			ver: 1,
			bIsLoading:false,
			masLenta:[],
			masApi_total:0,
			// count2page: 10,
			bIsPostForm: true,	
			strNote: '',			
			// fileUpload_model: '',
			p:1,
			bShowPaginBtn: false,
			objGetParams:{},
		}
	},
	computed: {

	},
	methods: {
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getLenta();
		},
		// pClick(){
		// 	this.p++;
		// 	this.getLenta(false,true);
		// },
		// pClick(e){
		// 	this.objGetParams['p'] = parseInt(e);
		// 	let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
		// 	this.$router.push({path: location.pathname+'?'+strItogGetParams});

		// 	this.getHistory();
		// },	
		getLenta(bEmited=false,bChangePage=false){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}
			this.bIsLoading = true;

			this.$GVO.ApiCall('GET',{obj:'MESSENGER_PROXY',flt:{/**/client_id:this.client_id, contact_type:'whatsapp',  ...filter/*contact_value:this.contact */}})
			// this.$GVO.ApiCall('GET',{obj:'MESSENGER_PROXY',flt:{client_id:this.client_id, }})
				.then((objApi) => { 
					this.bIsLoading = false;
					this.masApi_total = 0;

					if(objApi.success === true){
						// this.masLenta = objApi.data;
						// this.masLenta = this.$GVO.unlinkObject(objApi.data);
						
						this.masLenta = this.$GVO.unlinkObject(objApi.data);
						if(objApi.total!=undefined) { this.masApi_total=objApi.total; }

						// if(typeof objApi.data != 'undefined' && objApi.data.length < 10) {
						// 	this.bShowPaginBtn = false;
						// } else {this.bShowPaginBtn = true;}
						// if(!bChangePage){
						// 	this.masLenta = this.$GVO.unlinkObject(objApi.data);
							
						// }else{
						// 	// this.masLenta.anal = this.masLenta.anal.concat(this.$GVO.unlinkObject(objApi.data).anal);
						// 	// this.masLenta.note = this.masLenta.note.concat(this.$GVO.unlinkObject(objApi.data).note);
						// }
						
					} else {
						this.masApi_total=0;
					}
				}).catch(errorObjApi => {console.error(errorObjApi); this.masApi_total=0; this.bIsLoading = false;});
		
		},


		getNotes(id){
			// console.log(this.masLenta.id);
			if(typeof this.masLenta != 'undefined'){ 
				if(typeof this.masLenta.id != 'undefined'){ 					
					return this.masLenta.id;
				}
			}
			return {};
		},	

		// SendNote() {
		// 	let now = moment().format("YYYY-MM-DD HH:mm:ss");
			
		// 	this.$GVO.ApiCall('notice.INS',{
		// 		iData:{
		// 			'obj_type': 'WHATSAPP', // нужно где-то получать типы мессенджеров в будущем
		// 			'obj_id':this.client_id,
		// 			'obj_name': this.type,
		// 			'staff_name':this.$GVO.my_profile.fio,
		// 			'staff_code':this.$GVO.my_profile.code,

		// 			'contact_type': 'whatsapp', //this.contactType, нужно где-то получать типы мессенджеров в будущем ( см. файл клиента метод GET_CONTACTS_TYPES)
		// 			'contact_value': this.contact,
		// 			'message':this.strNote,
		// 			'dwl_date': now,
		// 			// 'atach_arr': this.fileUpload_model,	
		// 		}
		// 	}).then((objApi) => {
		// 		//console.log(objApi);
		// 		if(objApi.success === true){
		// 			if(objApi.data.length > 0) {
		// 				this.masLenta = objApi.data;
		// 			}
		// 			this.getLenta();	
		// 		} 	
		// 		this.bIsPostForm = !this.bIsPostForm;
		// 		// this.fileUpload_model = '';
		// 		this.strNote = ''; 
					
		// 	}).catch(errorObjApi => console.log(errorObjApi));			
		// },		
		SendNote() {
			let now = moment().format("YYYY-MM-DD HH:mm:ss");
			
			this.$GVO.ApiCall('MESSENGER_PROXY.INS',{
				iData:{
					// 'obj_type': 'WHATSAPP', 
					// 'obj_id':this.client_id,
					// 'obj_name': this.type,
					// 'staff_name':this.$GVO.my_profile.fio,
					// 'staff_code':this.$GVO.my_profile.code,

					// 'contact_type': 'whatsapp', 
					// 'contact_value': this.contact,
					// 'message':this.strNote,
					// 'dwl_date': now,
					// 'atach_arr': this.fileUpload_model,	

					'direction':'out',
					'staff_name':this.$GVO.my_profile.fio,
					'staff_code':this.$GVO.my_profile.code,
					'client_id':this.client_id,
					'client_name':this.client_name,
					'contact_type': 'whatsapp', //this.contactType, нужно где-то получать типы мессенджеров в будущем ( см. файл клиента метод GET_CONTACTS_TYPES)
					'contact_value': this.contact,
					'mess_type':'text',
					'mess_body':this.strNote,
					// 'atach_arr': this.fileUpload_model,	
				}
			}).then((objApi) => {
				//console.log(objApi);
				if(objApi.success === true){
					if(objApi.data.length > 0) {
						this.masLenta = objApi.data;
					}
					this.getLenta();	
				} 	
				this.bIsPostForm = !this.bIsPostForm;
				// this.fileUpload_model = '';
				this.strNote = ''; 
					
			}).catch(errorObjApi => console.error(errorObjApi));			
		},		
		showPostForm() {
			this.bIsPostForm = !this.bIsPostForm;
			this.$nextTick(() => {
				this.$refs.saveInput.focus();
			});

		},
		// DoDel(){			
		// 	this.fileUpload_model = '';
		// },
		// OnUploadFile(objData){
		// 	//console.log('OnUploadFile', objData);			
		// 	this.bUploading=true;
		// 	let objSendApi = {obj:'FileUpload',flt:{type:'notes_file'}};			
		// 	this.$GVO.UploadFile(objData.formId,'UniUpload',objSendApi)
		// 		.then(objApi => {  
		// 			//console.log(objApi);
		// 			if(objApi.success){
		// 				this.fileUpload_model = objApi.data;						
										
		// 			}else{
		// 				alert(objApi.msg);
		// 			}
		// 			this.bUploading=false;
		// 		})
		// 		.catch(errorObjApi => {console.log(errorObjApi); this.bUploading=false;});
		// },
		cancelForm() {
			this.bIsPostForm = !this.bIsPostForm;
			// this.fileUpload_model = '';
			this.strNote = '';
		},
		
	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		this.getLenta();	
	},
	created(){
		// eventEmitter.$on('reload_tasks',this.getLenta);
		eventEmitter.$on('reload_lenta',this.getLenta);
	},
	beforeDestroy() {
		// Отписываемся от события
		// eventEmitter.$off('reload_tasks',this.getLenta);
		eventEmitter.$off('reload_lenta', this.getLenta);
	},	
}
</script>

<style scoped>
	.ReClientChatNest {width: 100%; max-width: 1400px;}
	.overdue-text {color: #1d253b!important;}
/*============================ SEND NOTES ========================================*/
	.postAddForm-hide {
		display: none;
	}
	.postAddForm-show {
		display: block;
		margin-top: 15px;
	}
	.postForm {
		border: 1px solid transparent;
		border: 1px solid #01B0E0;
		border-radius: 0.2857rem;
		position: sticky;
		bottom: 0;		
	}
	.postForClick {padding: 15px 0px 0px 0px; cursor: pointer; width: 100%;}
	.postForm >>> .card-body {padding: 0px 5px 15px 10px!important;}
	.cancel-note-btn {position: absolute;  top: 0; right: 0;}
	.clientPage .card-collapse .postForm {
		background: #27293d;
	}
	.white-content .card:not(.card-white) .postForm {
		background: #fff;
	}
	.postForm:hover, .focus-shadow  {
		box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
	}
	.postForm h5 {
		margin-bottom: 0px;
	}
	.form-container {display: flex; flex-direction: column; justify-content: space-between; padding: 0px 5px;}
	.postForm .bottom_part, .top_part  {display: flex; flex-wrap: wrap; justify-content: space-between; height: 40px;}
	.postForm .bottom_part button, .fileinput {margin: 10px 10px 0px 0px;}

	.postAddForm >>> .nav-pills .nav-item i {line-height: 30px;}
	.postAddForm >>> .nav-pills .nav-item .nav-link {padding: 7px 20px; min-width: 80px;}
	.postAddForm >>> .tab-space {padding: 20px 0 10px 0px;}
	.upload-file {display: flex; align-items: center;}
	.upload-file h5 {margin-bottom: 0px; margin-right: 10px;}

	.note-btn-group {position: relative;}
	.note-btn-row {position: absolute; top: 5px; right: 0;}
	.ReClientChatNest .lenta-item, .ReClientChatNest .postForm {width: 55%;}

	.lenta-item.last .card-cinc {margin-bottom: 15px; }
	/*.BG-color-dark {background-color: #191f31!important;}
	.BG-color-light {background-color: #f1f6fc!important;}*/
	.msgDirectionIn {border: 1px solid #00BF9A;}
	.msgDirectionOut {border: 1px solid #9e77f3; background-color: #191f31;}
	.white-content .card:not(.card-white) .msgDirectionOut {background-color: #f1f6fc!important;}
	
	/* .offcetBlock {margin-left: 100px;} */

	/*===media===============================*/
		@media (max-width: 1200px) {
			.ReClientChatNest .lenta-item, .ReClientChatNest .postForm {width:70%;}
		}
		@media (max-width: 768px) {
			.ReClientChatNest .lenta-item, .ReClientChatNest .postForm {width: 85%;}
		}

    
</style>
